import React from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { render } from "react-dom";

import history from "./history";
import App from "./components/App";
import store from "./redux/reduxStore";

import "./membersCommon";

window.launchCA = async () => {
  const cookieconsent = window.initCookieConsent();

  if (cookieconsent.allowedCategory("performance")) {
    const { ApplicationInsights, DistributedTracingModes } = await import(
      "@microsoft/applicationinsights-web"
    );
    const { ReactPlugin } = await import(
      "@microsoft/applicationinsights-react-js"
    );

    const reactPlugin = new ReactPlugin();
    window.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: "a3d5233b-8d17-44f4-a4fc-5cc517bee696",
        distributedTracingMode: DistributedTracingModes.W3C,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history },
        },
      },
    });
    window.appInsights.loadAppInsights();
    window.appInsights.trackPageView();
  }

  render(
    <Router basename="/my-account" history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    document.getElementById("members-area-spa")
  );
};
window.launchCA();
